import analytics from 'extensions/analytics';
import {AppUserGroup} from 'store/slices/app/types';

export function reporter(_store: any) {
  return {
    initReporter: (
      _state: any,
      user: false | {ekey: string, email: string, group: AppUserGroup}) => {
      const userGroup = user ? user.group : AppUserGroup.Unregistered;
      const userId = user ? user.ekey : undefined;
      analytics.start('mfv2', userId, userGroup);
    },
    pluginReporter: (_store: any) => (next: any) => (action: any) => {
      analytics.log(action.type)
      try {
        return next(action);
      } catch(error) {
        analytics.notify(error);
      }
    },
  };
}
